import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import Login from "../pages/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import useAdminHttp from "../hooks/useAdminHttp";
import LoadingPage from "../pages/LoadingPage";
import { ADMIN_TOOL_ACCOUNT_USER_ROLE } from "../AdminConstants";

const AdminLayout = () => {

    const location = useLocation();
    const { isAdmin, setIsAdmin, setAdminToolAccountUserRole } = useAuth();
    const [isPinging, setIsPinging] = useState(true);
    const { fetchData } = useAdminHttp();
    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const response = await fetchData('ping', 'get', null);
                if (response?.status === 200) {
                    setIsAdmin(true);
                    const sessionResponse = await fetchData('session', 'get', null);
                    if (sessionResponse && sessionResponse.status === 200) {
                        const role = sessionResponse.data?.adminUser;
                        setAdminToolAccountUserRole(role ?? ADMIN_TOOL_ACCOUNT_USER_ROLE.USER);
                   
                    }
                } else {
                    setIsAdmin(false);
                    setAdminToolAccountUserRole(ADMIN_TOOL_ACCOUNT_USER_ROLE.USER);
                }
            } catch (error) {
                setIsAdmin(false);
                setAdminToolAccountUserRole(ADMIN_TOOL_ACCOUNT_USER_ROLE.USER);
                console.error(error);
            } finally {
                setIsPinging(false);
            }
        };
        checkAdminStatus();
    }, []);

    return (
        <>
            {
                isPinging ? <LoadingPage /> : (
                    isAdmin ?
                        <Dashboard /> : <Login />
                )
            }
        </>
    )
}

export default AdminLayout;